module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_srban'),
      "size": "small"
    },
    model: {
      value: (_vm.reasonDia),
      callback: function($$v) {
        _vm.reasonDia = $$v
      },
      expression: "reasonDia"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.app_banandrs)))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "placeholder": _vm.$t('app_banandrs'),
      "type": "textarea"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_suresm')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name')
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editInfo ? _vm.editInfo.firmwareName : '') + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.version')
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editInfo ? _vm.editInfo.version : '') + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editInfo ? _vm.editInfo.mechanismName : '') + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "24px",
      "margin-bottom": "12px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.reasonDia = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.pushTest
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tsazcs')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "size": "small",
      "title": _vm.$t('lin_global.zdtslb')
    },
    model: {
      value: (_vm.showTable),
      callback: function($$v) {
        _vm.showTable = $$v
      },
      expression: "showTable"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.input1),
      callback: function($$v) {
        _vm.input1 = $$v
      },
      expression: "input1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.new_add')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.give(scope.row.terminalNo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushInstallTest'),
      "size": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushInstall(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08463fd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/firmware/checkDetail.vue
// module id = 959
// module chunks = 0